module.exports = __webpack_public_path__ + "static/img/lb3.f6fa2a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/lb3.png
// module id = WWhl
// module chunks = 0